import type { ReactNode } from 'react';
import { Button, cn } from '@simplywallst/ui-core/next';

type Props = {
  children: ReactNode;
  isOpen: boolean;
  onDiscard: () => void;
  onCancel: () => void;
};

export const NarrativeMiniValuatorDiscardProgressConfirmation = ({
  children,
  isOpen,
  onDiscard,
  onCancel,
}: Props) => {
  return (
    <div className="relative">
      <div
        className={cn(
          'transition-[filter] duration-500',
          isOpen ? 'blur-sm' : 'blur-0'
        )}
      >
        {children}
      </div>
      {isOpen && (
        <div className="absolute inset-0 z-10 backdrop-blur-sm backdrop-brightness-75">
          <div className="grid h-full place-content-center">
            <div className="max-w-[260px]">
              <h4 className="mb-x2 text-pretty text-center text-xs">
                Are you sure you want to discard this narrative?
              </h4>
              <div className="grid grid-cols-[auto_auto] gap-x1">
                <Button variant="secondary" onClick={onDiscard}>
                  Yes
                </Button>
                <Button variant="primary" onClick={onCancel}>
                  No
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
